<template>
    <chart-constructor
        v-if="series.length > 0"
        :options="options"
     />
</template>

<script>
import Vue from 'vue';

export default Vue.extend({
  name: 'ModalChartPie',
  components: {
    'chart-constructor': () => import('@/components/charts/chartConstructor/index.js'),
  },
  props: {
    series: {
      type: Array,
      default: () => Array(),
    },
  },
  computed: {
    totalData () {
      return this.series.reduce((a, e) => a + e.y, 0);
    },
    options () {
      const that = this;
      return {
        chart: {
          type: 'pie',
          plotShadow: false,
          plotBorderWidth: null,
          plotBackgroundColor: null,
          height: 450,
          minHeight: 450,
        },
        title: {
          text: '',
        },
        tooltip: {
          positioner: function (boxWidth, boxHeight, point) {
            return { x: point.plotX + boxWidth + boxWidth / 2, y: point.plotY + boxHeight + boxHeight / 2 };
          },
          formatter: function () {
            return `<b>${this.key}</b>
                        <br><br>
                        <b>Count</b>: ${this.y}
                        <br>
                        <b>Percentage</b>: ${that.getPercentage(this.y)}%`;
          },
          outside: true,
        },
        plotOptions: {
          pie: {
            cursor: 'pointer',
            dataLabels: {
              distance: -70,
              formatter: function () {
                return `<b>${this.key}</b>
                                    <br>
                                    <b>${this.y} (${that.getPercentage(this.y)}%)</b>`;
              },
            },
          },
        },
        series: [{
          colorByPoint: true,
          data: this.series,
        }],
        exporting: {
          enabled: false,
        },
      };
    },
  },
  methods: {
    getPercentage (num) {
      return Number(num / this.totalData * 100).toFixed(2);
    },
  },
});
</script>

<style lang="scss">
    .highcharts-tooltip-container {
        z-index: 1000;
    }
</style>
